import Account from './Account';
import Auth from './Auth';
import Base from './Base';
import Contact from './Contact';
import Favorites from './Favorites';
import Index from './Index';
import Newsletter from './Newsletter';
import OnlineFilms from './OnlineFilms';
import Pages from './Pages';
import Purchases from './Purchases';
import Sections from './Sections';

class Api extends Base {
    constructor(opts = {}) {
        super(opts);
        const { indexSlugs = {} } = opts || {};

        this.auth = new Auth(this);
        this.account = new Account(this);
        this.contact = new Contact(this);
        this.pages = new Pages(this);
        this.sections = new Sections(this);
        this.films = new Index(this, indexSlugs.films || null);
        this.bundles = new Index(this, indexSlugs.films || null);
        this.events = new Index(this, indexSlugs.calendar || null);
        this.articles = new Index(this, indexSlugs.articles || null);
        this.pageSearch = new Index(this, indexSlugs.pages || null);

        this.favorites = new Favorites(this);
        this.purchases = new Purchases(this);
        this.onlineFilms = new OnlineFilms(this);
        this.newsletter = new Newsletter(this);
    }
}

export default Api;
